<template>
    <div>
        <v-flex>
            <v-btn class="secondary_btn"
                   data-qe-id="forum-location_choose-link"
                   @click="showMapPopup=true">{{mapConstants.CHOOSE_LOCATION}}</v-btn>
        </v-flex>
        <v-flex class="forumMap">
            <gmap-map :center="center" :zoom="15" :options="mapOptions">
                <gmap-marker :position="getMarker" :icon="icon"
                             data-qe-id="forum-location_marker-link"
                             @click="center=getMarker">
                </gmap-marker>
            </gmap-map>
        </v-flex>
        <v-dialog v-model="showMapPopup" content-class="large" persistent>
            <v-card class="forumMapPopup">
                <v-flex tag="h2">
                    {{mapConstants.CREATE_MEETING}}
                    <i class="fas fa-times" @click="showMapPopup=false" data-qe-id="forum-location_create-meeting"></i>
                </v-flex>
                <v-flex>
                    <strong>{{mapConstants.CHOOSE_LOCATION}}</strong>
                    <gmap-autocomplete @place_changed="setPlace">
                    </gmap-autocomplete>
                </v-flex>
                <br/>
                <gmap-map :center="center" :zoom="15" :options="mapOptions">
                    <gmap-marker :position="getMarker" :icon="icon" @click="center=getMarker"
                                 data-qe-id="forum-location_marker-secondary-link">
                    </gmap-marker>
                </gmap-map>
            </v-card>
            <v-flex>
                <v-btn class="primary_btn transparent"
                       data-qe-id="forum-location_back-btn"
                       @click="showMapPopup=false">
                    {{mapConstants.BACK}}
                </v-btn>
                <v-btn class="primary_btn" @click="saveMarker" data-qe-id="forum-location_save_btn">
                    {{mapConstants.DONE}}
                </v-btn>
            </v-flex>
        </v-dialog>
    </div>
</template>

<script>
    import { mapConstants } from '../ForumPage/ForumConstants';

    export default {
        mounted() {
            this.geolocate();
        },
        data() {
            return {
                mapConstants,
                mapOptions: {
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                },
                icon: {
                    url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                    scaledSize: {
                        width: 45,
                        height: 30,
                        f: 'px',
                        b: 'px',
                    },
                },
                center: {},
                lattitude: 0,
                longitude: 0,
                showMapPopup: false,
                address: '',
            };
        },
        computed: {
            getMarker() {
                const position = {
                    lat: this.lattitude,
                    lng: this.longitude,
                };
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.center = position;
                return position;
            },
        },
        methods: {
            setPlace(place) {
                this.lattitude = place.geometry.location.lat();
                this.longitude = place.geometry.location.lng();
                this.address = place.formatted_address;
            },
            saveMarker() {

            },
            geolocate() {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.lattitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                });
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .forumMapPopup {
        h2 {
            position: relative;
            background: $ypo-cta;
            font-size: 14px;
            color: $white;
            padding: 12px 20px;
            font-family: Raleway;

            i {
                cursor: pointer;
                position: absolute;
                right: 15px;
                top: 15px;
            }
        }

        .vue-map-container {
            height: 400px;
        }
    }
    .forumMap .vue-map-container {
            height: 200px;
        }
</style>
